export default __webpack_public_path__ + "static/media/arrow1.3f622263.svg";